import { render } from "./FAQBanner.vue?vue&type=template&id=e494798e&scoped=true"
import script from "./FAQBanner.vue?vue&type=script&lang=js"
export * from "./FAQBanner.vue?vue&type=script&lang=js"

import "./FAQBanner.vue?vue&type=style&index=0&id=e494798e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e494798e"

export default script